import { Container, Flex, Grid, Skeleton } from '@backstage/ui';
import { paginationOptions } from './config';

const TABLE_ROW_COUNT = paginationOptions.pageSize;

/**
 * Loading placeholder that mirrors the Pulse Track/Check details layout
 * (title, description, owner, filter bar, two status cards, and a results table) so the page
 * keeps its shape while data is fetched.
 */
export const PulseDetailsSkeleton = () => (
  <Container>
    <Flex direction="column" gap="12">
      <Flex direction="column" gap="3">
        <Skeleton width={300} height="var(--bui-space-10)" />
        <Skeleton width="100%" height="var(--bui-space-8)" />
        <Skeleton width={200} height="var(--bui-space-5)" />
        <Skeleton width="100%" height="var(--bui-space-8)" />
      </Flex>

      <Grid.Root columns={{ initial: '1', lg: '2' }} gap="4">
        <Grid.Item>
          <Skeleton width="100%" height={200} />
        </Grid.Item>
        <Grid.Item>
          <Skeleton width="100%" height={200} />
        </Grid.Item>
      </Grid.Root>

      <Flex direction="column" gap="2">
        <Skeleton width="100%" height={44} />
        {Array.from({ length: TABLE_ROW_COUNT }, (_, index) => (
          <Skeleton
            key={`row-${index}`}
            width="100%"
            height="var(--bui-space-8)"
          />
        ))}
      </Flex>
    </Flex>
  </Container>
);
